module.exports = __webpack_public_path__ + "static/media/20170506-_DSC005902.ec81f83d.jpg";